<template>
	<div>
		<nav class="panel">
			<p class="panel-heading">
				検索フィルタ
			</p>
			<div class="filter-panel">
				<div class="level">
					<div class="level-left">
						<div class="level-item">
							<div class="control">
								<b-radio v-model="dateFilterType"
									size="is-medium"
									native-value="3"
									@input="onDateFilterTypeChange"
									>
									指定なし
								</b-radio>
								<b-radio v-model="dateFilterType"
									size="is-medium"
									native-value="1"
									@input="onDateFilterTypeChange"
									>
									本日
								</b-radio>
								<b-radio v-model="dateFilterType"
									size="is-medium"
									native-value="2"
									@input="onDateFilterTypeChange"
									>
									日付指定
								</b-radio>
							</div>
							<div class="date-picker">
								<date-picker :dateProvided="filterDate" @input="onFilterDateInput"></date-picker>
							</div>
						</div>
					</div>

					<div class="level-right">
						<div class="level-item">
							<button class="button is-success search-button" @click="onSearchButtonClick">検索</button>
						</div>
					</div>
				</div>
			</div>
		</nav>

		<section>
			<b-table
				:data="data"
				:loading="loading"
				:default-sort-direction="defaultSortDirection"
				default-sort="created"
				detailed
				detail-key="id"
				:show-detail-icon="showDetailIcon"
				>

				<template slot-scope="props">
					<b-table-column field="id" label="ID" sortable>
						{{ props.row.id }}
					</b-table-column>

					<b-table-column field="staff_name" label="スタッフ名" sortable>
						{{ props.row.staff_name }}
					</b-table-column>

					<b-table-column field="created" label="登録日時" sortable>
						{{ props.row.created }}
					</b-table-column>

					<b-table-column field="name" label="名前" sortable>
						{{ props.row.name }}
					</b-table-column>
				</template>
		
				<template slot="detail" slot-scope="props">
					<ul class="detail">
						<li>
							<div class="detail-title">端末種類</div>
							<div class="detail-value">{{ props.row.device_type }}</div>
						</li>
						<li>
							<div class="detail-title">利用年数</div>
							<div class="detail-value">{{ props.row.use_term }}</div>
						</li>
						<li>
							<div class="detail-title">SB</div>
							<div class="detail-value">{{ props.row.phone_status_sb }}</div>
						</li>
						<li>
							<div class="detail-title">ドコモ</div>
							<div class="detail-value">{{ props.row.phone_status_docomo }}</div>
						</li>
						<li>
							<div class="detail-title">au</div>
							<div class="detail-value">{{ props.row.phone_status_au }}</div>
						</li>
						<li>
							<div class="detail-title">Ymobile</div>
							<div class="detail-value">{{ props.row.phone_status_ymobile }}</div>
						</li>
						<li>
							<div class="detail-title">その他</div>
							<div class="detail-value">{{ props.row.phone_status_etc }}</div>
						</li>
					</ul>

					<ul class="detail">
						<li>
							<div class="detail-title">携帯料金月額</div>
							<div class="detail-value">{{ props.row.phone_cost_monthly }}</div>
						</li>
						<li>
							<div class="detail-title">携帯料金台数</div>
							<div class="detail-value">{{ props.row.phone_cost_number }}</div>
						</li>
						<li>
							<div class="detail-title">携帯料金合計</div>
							<div class="detail-value">{{ props.row.phone_cost_total }}</div>
						</li>
					</ul>

					<ul class="detail">
						<li>
							<div class="detail-title">ネット利用状況</div>
							<div class="detail-value">{{ props.row.internet_status }}</div>
						</li>
						<li>
							<div class="detail-title">ネット料金</div>
							<div class="detail-value">{{ props.row.internet_cost }}</div>
						</li>
						<li>
							<div class="detail-title">ネット</div>
							<div class="detail-value"><span v-if="props.row.internet_cost_net"><i class="fas fa-check"></i></span></div>
						</li>
						<li>
							<div class="detail-title">電話</div>
							<div class="detail-value"><span v-if="props.row.internet_cost_tel"><i class="fas fa-check"></i></span></div>
						</li>
						<li>
							<div class="detail-title">テレビ</div>
							<div class="detail-value"><span v-if="props.row.internet_cost_tv"><i class="fas fa-check"></i></span></div>
						</li>
					</ul>

					<ul class="detail">
						<li>
							<div class="detail-title">電話番号</div>
							<div class="detail-value">{{ props.row.tel }}</div>
						</li>
						<li>
							<div class="detail-title">年代</div>
							<div class="detail-value">{{ props.row.age }}</div>
						</li>
						<li>
							<div class="detail-title">性別</div>
							<div class="detail-value">{{ props.row.gender }}</div>
						</li>
					</ul>

					<div class="columns">
						<div class="column is-three-quarters">
							<b-field>
								<b-input type="textarea" placeholder="メモ欄" v-model="memo[props.row.id]"></b-input>
							</b-field>
						</div>
						<div class="column">
							<button class="button is-success memo-button" :class="{ 'is-loading': isMemoButtonLoading }" @click="onMemoButtonClick(props.row.id)">メモ更新</button>
						</div>
					</div>
				</template>

				<template slot="empty">
					<section class="section">
						<div class="content has-text-grey has-text-centered">
							<p>データはありません</p>
						</div>
					</section>
				</template>
			</b-table>
		</section>
	</div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
import DatePicker from '@/components/DatePicker'

export default {
	name: 'survey-summary',
	components: {
		DatePicker,
	},
	data() {
		return {
			data: [],
			loading: false,
			defaultSortDirection: 'desc',
			defaultOpenedDetails: [1],
			showDetailIcon: true,
			mobileNative: false,
			dateFilterType: '1',
			filterDate: '',
			memo: [],
			isMemoButtonLoading: false,
		}
	},
	mounted() {
		this.init();
		this.$store.commit('basic', {
			key: 'titleBarTitleStack',
			value: ['アンケートサマリー']
		});
	},
	methods: {
		onMemoButtonClick: async function(id) {
			this.$utils.log(id);
			this.$utils.log(this.memo[id]);

			this.isMemoButtonLoading = true;
			let data = {
				"id": id,
				"memo": (!this.memo[id]) ? '' : this.memo[id],
			};
			this.$utils.log(data);

			try {
				let res = await this.$api.post('surveys', data, true);
				this.$utils.log(res);
				this.$utils.toastSuccess('メモを更新しました');
			} catch (error) {
				this.$utils.log(error);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isMemoButtonLoading = false;
			}
		},
		init: function() {
			this.getData();
		},
		toggle(row) {
			this.$refs.table.toggleDetails(row)
		},
		onFilterDateInput: function(date) {
			this.$utils.log('onFilterDateInput');
			this.filterDate = date;
			this.dateFilterType = '2';
		},
		onDateFilterTypeChange: function() {
			this.$utils.log('onDateFilterTypeChange');
			if (this.dateFilterType === '1' || this.dateFilterType === '3') {
				this.filterDate = '';
			}
		},
		onSearchButtonClick: function() {
			this.$utils.log('onSearchButtonClick');
			this.getData();
		},
		getData: async function() {
			this.$utils.log('getData');
			this.loading = true;
			let data = {
				"date_filter_type": this.dateFilterType,
				"filter_date": this.filterDate,
			};
			this.$utils.log(data);

			let ep = 'surveys?' + qs.stringify(data);
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				let list = res.data.list;
				if (list === null) {
					this.data = [];
				} else {
					this.data = list;

					// メモは更新するので別処理
					for (let i in list) {
						this.memo[list[i].id] = list[i].memo;
					}
				}
			} catch (error) {
				this.$utils.log(error);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.loading = false;
			}
		},
	},
}
</script>

<style scoped>
.panel-block {
	display: flex;
	align-items: center;
}
.panel-heading {
	padding-left: 1.5rem;
}
.datepicker {
	margin-right: 30px;
	width: 150px;
}
.filter-panel {
	padding: 10px 20px;
	border: 1px solid #dbdbdb;
	border-top: none;
}
label.b-radio {
	margin-right: 10px;
}
.fa-check {
	color: #23d160;
}
ul.detail {
	margin-bottom: 10px;
}
ul.detail li {
	width: 135px;
	margin-bottom: 10px;
}
.detail-value {
}
.date-picker {
	margin-right: 20px;
}
</style>
